// employee-portal-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'emp.status.received': 'Received',
  'emp.change.submitted': 'Submitted',
  'emp.change.resubmitted': 'Resubmitted',
  'emp.change.updated': 'Changed',
  'emp.change.withdrawn': 'Withdrawn',
  'emp.change.byEmployer': 'employer',
  'emp.change.byYou': 'you',
  'emp.change.text': '{action} by {who}',
  'emp.employerFallback': 'Employer',
  'emp.employeeFallback': 'Employee',
  'emp.orgNumber': 'Org. {org}',
  'emp.accountingClient': 'Accounting client',
  'emp.bg.default': 'Plum',
  'emp.bg.mint': 'Mint',
  'emp.bg.varm': 'Warm',
  'emp.bg.sky': 'Blue',
  'emp.bg.rose': 'Rose',
  'emp.bg.skog': 'Forest',
  'emp.portalNotConnected': 'The employee portal is not connected to the backend.',
  'emp.portalFetchFailed': 'Could not load the employee portal.',
  'emp.attachReceipt': 'Attach receipt',
  'emp.attachmentFallback': 'Attachment',
  'emp.expenseFillIn': 'Fill in category, amount and description, and attach a voucher.',
  'emp.voucherSentToBookkeeping': 'The voucher has been sent for bookkeeping.',
  'emp.expenseSentForApproval': 'Expense sent for approval.',
  'emp.expenseSendFailed': 'Could not send the expense.',
  'emp.sending': 'Sending...',
  'emp.sendToBookkeeping': 'Send for bookkeeping',
  'emp.sendForApproval': 'Send for approval',
  'emp.travelFillIn': 'Fill in purpose, date and destination.',
  'emp.lineExpenseRequired': 'Description, amount and voucher are required.',
  'emp.attachmentUploadFailed': 'Could not upload the voucher.',
  'emp.mileageFillIn': 'Fill in from, to and kilometres.',
  'emp.accommodationFillIn': 'Enter a description of the place of accommodation.',
  'emp.editMileage': 'Edit trip',
  'emp.newMileage': 'New trip',
  'emp.editAccommodation': 'Edit overnight stay',
  'emp.newAccommodation': 'New overnight stay',
  'emp.editExpense': 'Edit expense',
  'emp.newExpense': 'New expense',
  'emp.saving': 'Saving...',
  'emp.save': 'Save',
  'emp.add': 'Add',
  'emp.currency.NOK': 'Norwegian kroner',
  'emp.currency.EUR': 'Euro',
  'emp.currency.USD': 'US dollars',
  'emp.currency.GBP': 'British pounds',
  'emp.currency.SEK': 'Swedish kronor',
  'emp.currency.DKK': 'Danish kroner',
  'emp.currency.CHF': 'Swiss francs',
  'emp.currency.ISK': 'Icelandic krónur',
  'emp.currency.PLN': 'Polish zloty',
  'emp.currency.AUD': 'Australian dollars',
  'emp.currency.CAD': 'Canadian dollars',
  'emp.draftSaved': 'Draft saved.',
  'emp.draftSaveFailed': 'Could not save the draft.',
  'emp.travelResubmitted': 'Trip resubmitted.',
  'emp.travelSentForApproval': 'Trip sent for approval.',
  'emp.travelSendFailed': 'Could not send the trip.',
  'emp.confirmWithdraw': 'Withdraw the trip back to draft? The employer cannot process it until you submit it again.',
  'emp.travelWithdrawn': 'The trip has been withdrawn and can be edited.',
  'emp.withdrawFailed': 'Could not withdraw the trip.',
  'emp.confirmDeleteExpenseOfTravel': 'Delete the expense? This also removes it from the employer\'s approval.',
  'emp.confirmDeleteTravel': 'Delete the trip? This also removes it from the employer\'s approval.',
  'emp.expenseDeleted': 'Expense deleted.',
  'emp.travelDeleted': 'Trip deleted.',
  'emp.deleteFailed': 'Could not delete.',
  'emp.editLine': 'Edit line',
  'emp.withdrawing': 'Withdrawing...',
  'emp.withdraw': 'Withdraw',
  'emp.close': 'Close',
  'emp.saveDraft': 'Save draft',
  'emp.resubmit': 'Resubmit',
  'emp.submitTravel': 'Submit trip',
  'emp.fixAndResubmit': 'Correct the trip and submit it again.',
  'emp.changedAfterSubmit': 'Changed after submission',
  'emp.changedAfterSubmitText': 'The trip was changed after you submitted it. See the history at the bottom.',
  'emp.addLinesToStart': 'Add a trip, expense or stay to get started.',
  'emp.dietCalculated': 'Per diem is calculated',
  'emp.noDiet': 'No per diem (expenses/driving only)',
  'emp.noPayrollPayout': 'This trip has no expenses or allowances to be paid out as salary.',
  'emp.history': 'History',
  'emp.totalCount': '{count} in total',
  'emp.payrollRunFallback': 'Payroll run',
  'emp.expenseFallback': 'Expense',
  'emp.voucherFetchFailed': 'Could not fetch the voucher.',
  'emp.noPreviewLink': 'Could not find a preview link for the voucher.',
  'emp.confirmDeleteExpense': 'Delete the expense? This also removes it from the employer\'s approval.',
  'emp.expenseDeleteFailed': 'Could not delete the expense.',
  'emp.deleting': 'Deleting...',
  'emp.delete': 'Delete',
  'emp.noAttachmentFound': 'No attachment found',
  'emp.tapToPreview': 'Tap to open the preview.',
  'emp.noAttachmentName': 'This expense has no attachment name in the employee portal.',
  'emp.previewFetchFailed': 'Could not fetch the voucher for preview.',
  'emp.travelFallback': 'Trip',
  'emp.connectingEmployers': 'Connecting to your employers.',
  'emp.noActiveAccess': 'You have no active employee portal access with this email.',
  'emp.payslipsAvailable': '{count} payslips available',
  'emp.noPayslipsReady': 'No payslips are ready yet.',
  'emp.pendingApprovedSummary': '{pending} awaiting approval - {approved} approved',
});
